<template>
  <body class="pt-12">
    <div v-if="loadGimbal">
      <img
        height="1"
        width="1"
        style="border-style: none"
        alt=""
        src="https://insight.adsrvr.org/track/pxl/?adv=udguyav&ct=0:bzf5olo&fmt=3"
      />
    </div>
    <section :class="`pb-5 ${titleBackgroundColor}`">
      <div class="container py-16">
        <div class="flex">
          <div
            class="hidden lg:flex flex-col w-1/6 my-5 bg-no-repeat bg-contain"
            style="background-image: url(./img/sketches/sun_two_clouds.png)"
          ></div>
          <div class="lg:hidden px-2 flex flex-col w-full lg:w-4/6 mx-auto">
            <h1 :class="`mt-4 text-center text-4xl lg:text-5xl ${textColor} font-black`">
              {{ title }}
            </h1>
            <div v-if="category === 'shepherd'" class="lg:hidden flex justify-center">
              <img
                src="img/misc/shepherd_logo4C.png"
                alt="Shepherd Center"
                class="items-center w-3/4 py-1"
              />
            </div>

            <h2 :class="`mt-3 text-center text-2xl lg:text-3xl ${textColor}`">
              Loans based on employment!
            </h2>
            <ul>
              <li :class="`text-center mt-3 text-lg lg:text-xl ${textColor}`">
                <i class="fas fa-check fa-sm"></i> Personal loans up to $10,000
              </li>
              <li :class="`text-center text-lg lg:text-xl ${textColor}`">
                <i class="fas fa-check fa-sm"></i> Terms up to 24 months
              </li>
            </ul>
            <div class="flex justify-center mt-3">
              <base-button
                class="rounded px-6 py-4"
                @click="applyNow"
                aria-label="apply"
                type="primary text-lg"
              >
                Check My Rate
              </base-button>
            </div>
            <h2 :class="`text-center text-md ${textColor} mt-2 mb-2`">Check my rate for free!</h2>
            <div class="flex flex-wrap gap-6 justify-center text-left mt-1">
              <span :class="`text-lg ${textColor} mr-3`"
                ><i class="fas fa-dollar-sign"></i> Cover Expenses</span
              >
              <span :class="`text-lg ${textColor} mr-3`"
                ><i class="fas fa-piggy-bank"></i> Refinance Debt</span
              >
              <span :class="`text-lg ${textColor} mr-3`"
                ><i class="fas fa-chart-line"></i> Build Your Credit</span
              >
            </div>
          </div>
          <div class="lg:flex hidden flex-col w-4/6 mx-auto">
            <h1 :class="`titlemargin text-center text-5xl ${textColor} font-black`">
              {{ title }}
            </h1>
            <div v-if="category === 'shepherd'" class="hidden lg:flex justify-center">
              <img
                src="img/misc/shepherd_logo4C.png"
                alt="Shepherd Center"
                class="items-center w-1/2 py-1"
              />
            </div>
            <h2 :class="`text-center text-2xl lg:text-3xl ${textColor}`">
              Loans based on employment!
            </h2>
            <ul>
              <li :class="`text-center mt-3 text-xl lg:text-xl ${textColor}`">
                <i class="fas fa-check fa-sm"></i> Personal loans up to $10,000
              </li>
              <li :class="`text-center text-xl lg:text-xl ${textColor}`">
                <i class="fas fa-check fa-sm"></i> Terms up to 24 months
              </li>
            </ul>
            <div class="flex justify-center my-6">
              <base-button
                class="rounded px-16 py-6"
                @click="applyNow"
                aria-label="apply"
                type="primary text-3xl"
              >
                Check My Rate
              </base-button>
            </div>
            <h2 :class="`text-center text-md ${textColor} mt-2 mb-2`">Check my rate for free!</h2>
            <div class="flex flex-wrap justify-center gap-6 text-left mt-2">
              <span :class="`text-xl ${textColor} mr-3`"
                ><i class="fas fa-dollar-sign"></i> Cover Expenses</span
              >
              <span :class="`text-xl ${textColor} mr-3`"
                ><i class="fas fa-piggy-bank"></i> Refinance Debt</span
              >
              <span :class="`text-xl ${textColor} mr-3`"
                ><i class="fas fa-chart-line"></i> Build Your Credit</span
              >
            </div>
          </div>
          <div
            class="hidden lg:flex flex-col w-1/6 bg-contain bg-right-bottom bg-no-repeat"
            style="background-image: url(./img/sketches/announcement.svg)"
          ></div>
        </div>
      </div>
    </section>
    <section class="pb-2 px-2">
      <h1 class="mt-4 mb-5 text-center text-4xl font-black lg:text-5xl">
        The <span class="viva-blue-text">VIVA </span> Difference
      </h1>
      <div class="container mx-auto flex content-smart mb-4">
        <!-- <div class="md:hidden   w-full mx-auto text-center md:text-left lg:w-1/2">
        <div class="hidden md:inline w-full mx-auto text-left   lg:w-1/2"> -->
        <div class="md:inline w-full mx-auto text-center md:text-left lg:w-1/2">
          <h2 class="font-black text-xl">{{ subTitle1 }}</h2>
          <p v-if="this.category === 'fast-loans'" class="text-lg">
            VIVA offers fast loans for <span class="viva-green-text"> any credit</span>, ready for
            any <span class="viva-blue-text">emergency</span>.
          </p>
          <p v-else class="text-lg">
            Loans with VIVA are based on
            <span class="viva-green-text font-bold"> employment</span>, instead of just your credit
            score.<button type="btn" aria-label="scroll to footer" @click="scrollToBottom()">
              *
            </button>
          </p>
          <h2 class="font-black pt-4 text-xl">2. Effortless Repayment</h2>
          <p class="text-lg">
            Make payments through direct deposit so you can
            <span class="viva-green-text font-bold"> set it and forget it</span>.
          </p>
          <h2 class="font-black pt-4 text-xl">{{ this.subTitle3 }}</h2>
          <p v-if="this.category === 'fast-loans'" class="text-lg">
            VIVA's online application process takes less than
            <span class="viva-green-text">10 minutes</span>, and you can receive your funds as soon
            as the <span class="viva-blue-text">next day</span>!
          </p>
          <p v-else class="text-lg">
            VIVA's online application process takes
            <span class="viva-green-text font-bold">5-10 minutes</span>. Receive a decision
            <span class="viva-green-text font-bold">within 24 hours</span>.
          </p>
        </div>
        <div
          class="hidden lg:flex w-1/2 bg-contain bg-center bg-no-repeat"
          style="background-image: url(./img/sketches/celebrating.svg)"
        ></div>
      </div>
    </section>
    <section class="section viva-blue section-lg pt-lg-0 mt-6 py-10">
      <h1 class="text-center text-4xl lg:text-5xl pt-3 text-white font-black">
        See what people are saying about VIVA
      </h1>
      <div class="container pt-3 pb-4">
        <div class="flex">
          <div class="col-lg-12">
            <div
              class="row flex flex-wrap md:flex-no-wrap px-2 md:px-2 gap-6 items-center justify-center"
            >
              <div class="col-lg-4">
                <div
                  class="card card-lift--hover dashboard-card dashboard-card-hover card-shadow border-0 text-center"
                >
                  <div class="card-body pt-2 lg:h-40">
                    <div class="flex flex-col items-center justify-center mb-2">
                      <p class="text-yellow-500 text-3xl">★★★★★</p>
                      <h3 class="h3">
                        “...They were professional, hassle-free, and produced really quick results.
                        I'd not only give them 5 stars, but they also get 2 thumbs up!”
                      </h3>
                    </div>
                    <p class="px-2 description mt-2">- Albert</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div
                  class="card card-lift--hover dashboard-card dashboard-card-hover card-shadow border-0 text-center"
                >
                  <div class="card-body pt-2 lg:h-40">
                    <div class="flex flex-col items-center justify-center mb-2">
                      <p class="text-yellow-500 text-3xl">★★★★★</p>
                      <h3 class="h3">
                        “The best experience ever while receiving a loan. The process was easy and
                        quick... My money was really deposited the next day!”
                      </h3>
                    </div>
                    <p class="px-2 description mt-2">- Cherelle</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div
                  class="card card-lift--hover dashboard-card dashboard-card-hover card-shadow border-0 text-center"
                >
                  <div class="card-body pt-2 lg:h-40">
                    <div class="flex flex-col items-center justify-center mb-2">
                      <p class="text-yellow-500 text-3xl">★★★★★</p>
                      <h3 class="h3">
                        “I am so glad that VIVA approved me for a loan! My mind is at ease now...
                        I'm in a much better place financially. Thank you VIVA!”
                      </h3>
                    </div>
                    <p class="px-2 description mt-2">- Rodney</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="flex justify-center my-5">
      <base-button
        class="rounded px-6 py-4"
        @click="applyNow"
        aria-label="apply"
        type="primary text-lg"
      >
        Get Started Today
      </base-button>
    </div>

    <h1 class="mt-4 text-center text-2xl lg:text-3xl viva-blue-text font-bold italic my-5">
      Be Financially Empowered
    </h1>
  </body>
</template>

<script>
import marketingEmployers from '@/assets/marketingEmployers.json'
export default {
  name: 'landing-page',
  data() {
    return {
      marketingEmployers
    }
  },
  methods: {
    applyNow() {
      let q = this.$route.query
      if (this.$store.getters.authenticated) {
        this.$router.push({ name: 'Apply', query: q })
      } else {
        this.$store.commit('applicationData/setApplyNowRoute', window.location.href)
        this.$router.push({ path: '/register', query: q })
      }
    },
    scrollToBottom() {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
    }
  },
  computed: {
    approvedEmployers() {
      return Object.keys(this.marketingEmployers['titleMapping'])
    },
    category() {
      if (this.$route.query && this.$route.query.employer) {
        const routeEmployer = this.$route.query.employer
        const lcEmployer = routeEmployer ? routeEmployer.toLowerCase() : ''
        console.log('Employer', lcEmployer)
        return this.approvedEmployers.includes(lcEmployer) ? lcEmployer : 'default'
      } else {
        let strippedPath = this.$route.path.replace('/', '').replace('employer-', '').toLowerCase()
        console.log(strippedPath)
        return this.approvedEmployers.includes(strippedPath) ? strippedPath : 'default'
      }
    },
    loadGimbal() {
      return this.category === 'healthcare'
    },
    textColor() {
      if (this.category === 'shepherd') {
        return 'text-shepherd-blue-100'
      }
      return 'text-white'
    },
    titleBackgroundColor() {
      if (this.category === 'shepherd') {
        return 'bg-white'
      }
      return 'viva-blue'
    },
    title() {
      return this.marketingEmployers.titleMapping[this.category]
    },
    subTitle1() {
      if (this.category === 'bad-credit' || this.category === 'personal-loans') {
        return '1. Personal Loans for Bad Credit'
      } else if (this.category === 'fast-loans') {
        return '1. Need an Emergency Loan?'
      } else {
        return '1. Your Credit is More Than a Number'
      }
    },
    subTitle3() {
      if (this.category === 'fast-loans') {
        return '3. Fast and Easy!'
      } else {
        return '3. Quick and Easy!'
      }
    }
  }
}
</script>

<style lang="less">
.header-letter {
  width: 100%;
  max-width: 340px !important;
  font-weight: bold;
  color: white;
  text-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  padding-bottom: 50px;
  font-size: 120px;
}
@media (min-width: 768px) {
  .header-letter {
    font-size: 260px;
  }
}
.header-body > div {
  height: 300px;
}
@media (min-width: 768px) {
  .header-body > div {
    height: 600px;
  }
}
.header-bg {
  background-blend-mode: multiply;
}
// .column {
//   float: left;
// }
.titlemargin {
  margin-top: 10vh;
}
.screenfill {
  height: 100vh;
}
.left {
  width: 15%;
}

.middle {
  width: 60%;
}

.right {
  width: 15%;
}
</style>
